import { useLayoutEffect, useEffect, useState, useRef } from 'react';
import { patchResizeHandler, createNotifier, isSSR } from './utils';
const useEnhancedEffect = isSSR() ? useEffect : useLayoutEffect;
function useResizeDetector(props = {}) {
    const { skipOnMount = false, refreshMode, refreshRate = 1000, refreshOptions, handleWidth = true, handleHeight = true, targetRef, observerOptions, onResize, } = props;
    const skipResize = useRef(skipOnMount);
    const localRef = useRef(null);
    const ref = (targetRef !== null && targetRef !== void 0 ? targetRef : localRef);
    const resizeHandler = useRef();
    const [size, setSize] = useState({
        width: undefined,
        height: undefined,
    });
    useEnhancedEffect(() => {
        if (isSSR()) {
            return undefined;
        }
        const notifyResize = createNotifier(onResize, setSize, handleWidth, handleHeight);
        const resizeCallback = (entries) => {
            if (!handleWidth && !handleHeight)
                return;
            entries.forEach((entry) => {
                const { width, height } = (entry && entry.contentRect) || {};
                const shouldSetSize = !skipResize.current && !isSSR();
                if (shouldSetSize) {
                    notifyResize({ width, height });
                }
                skipResize.current = false;
            });
        };
        resizeHandler.current = patchResizeHandler(resizeCallback, refreshMode, refreshRate, refreshOptions);
        const resizeObserver = new window.ResizeObserver(resizeHandler.current);
        if (ref.current) {
            // Something wrong with typings here...
            resizeObserver.observe(ref.current, observerOptions);
        }
        return () => {
            resizeObserver.disconnect();
            const patchedResizeHandler = resizeHandler.current;
            if (patchedResizeHandler && patchedResizeHandler.cancel) {
                patchedResizeHandler.cancel();
            }
        };
    }, [refreshMode, refreshRate, refreshOptions, handleWidth, handleHeight, onResize, observerOptions, ref.current]);
    return Object.assign({ ref }, size);
}
export default useResizeDetector;
